"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linksGridButtonsProps = exports.linksGridColumnsArray = exports.linksGridThemeArray = exports.linksGridButtonColorArray = exports.LinksGridButtonColor = exports.LinksGridTheme = exports.DEFAULT_MENU_NAME = exports.DEFAULT_GAP = void 0;

var _linksGridButtonsProp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_GAP = 15;
exports.DEFAULT_GAP = DEFAULT_GAP;
var DEFAULT_MENU_NAME = 'Shop by category';
exports.DEFAULT_MENU_NAME = DEFAULT_MENU_NAME;
var LinksGridTheme;
exports.LinksGridTheme = LinksGridTheme;

(function (LinksGridTheme) {
  LinksGridTheme["WHITE"] = "white";
  LinksGridTheme["SEASHELL"] = "seashell";
  LinksGridTheme["MOCASSIN"] = "mocassin";
  LinksGridTheme["CLARET"] = "claret";
  LinksGridTheme["BLACK"] = "black";
})(LinksGridTheme || (exports.LinksGridTheme = LinksGridTheme = {}));

var LinksGridButtonColor;
exports.LinksGridButtonColor = LinksGridButtonColor;

(function (LinksGridButtonColor) {
  LinksGridButtonColor["CLARET"] = "claret";
  LinksGridButtonColor["DBI_BLACK"] = "dbi-black";
  LinksGridButtonColor["MOCASSIN"] = "mocassin";
  LinksGridButtonColor["SEASHELL"] = "seashell";
  LinksGridButtonColor["DBI_BLACK_GHOST"] = "dbi-black-ghost";
  LinksGridButtonColor["WHITE_GHOST"] = "white-ghost";
})(LinksGridButtonColor || (exports.LinksGridButtonColor = LinksGridButtonColor = {}));

var linksGridButtonColorArray = Object.values(LinksGridButtonColor);
exports.linksGridButtonColorArray = linksGridButtonColorArray;
var linksGridThemeArray = Object.values(LinksGridTheme);
exports.linksGridThemeArray = linksGridThemeArray;
var linksGridColumnsArray = ['3', '4'];
exports.linksGridColumnsArray = linksGridColumnsArray;
var linksGridButtonsProps = (_linksGridButtonsProp = {}, _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.CLARET, {
  variant: 'solid',
  color: 'primaryDark',
  accentColor: 'white'
}), _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.DBI_BLACK, {
  variant: 'solid',
  color: 'gray800',
  accentColor: 'white'
}), _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.MOCASSIN, {
  variant: 'solid',
  color: 'secondary',
  accentColor: 'gray800'
}), _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.SEASHELL, {
  variant: 'solid',
  color: 'secondaryLight',
  accentColor: 'gray800'
}), _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.DBI_BLACK_GHOST, {
  variant: 'outlined',
  color: 'gray800',
  accentColor: 'gray800'
}), _defineProperty(_linksGridButtonsProp, LinksGridButtonColor.WHITE_GHOST, {
  variant: 'outlined',
  color: 'white',
  accentColor: 'white'
}), _linksGridButtonsProp);
exports.linksGridButtonsProps = linksGridButtonsProps;